import React, {useEffect} from "react";
import {useAuth} from "hooks/useAuth";
import {ApiGetTagsBrio} from "../api/testTags";
import CustomDataTable from "shared/tables/CustomDataTable";
import useDataTable from "../../../../hooks/useDataTable";

type Tag = {
    name: string;
};

const COLUMNS = [
    {id: "name", label: "Nume", numeric: false, disablePadding: false, sortable: false, noWrap: true,},
];

const BrioTags = () => {
    const { update } = useAuth();

    const {
        loading,
        setLoading,
        tableData,
        setTableData,
        page,
        perPage,
        setPerPage,
        totalRows,
        setTotalRows,
    } = useDataTable("", "", undefined, "");

    useEffect(() => {
        setLoading(true);
        ApiGetTagsBrio()
            .then((response) => {
                if (response.data.success) {
                    // console.log("getBrioTags OK", response);
                    setTableData(response.data.data.values.map((tag: Tag) => ({ name: tag })));
                    setTotalRows(response.data.data.values.length);
                    setPerPage(response.data.data.values.length);
                } else {
                    update("error", { show: true, code: "A002" });
                }
            })
            .catch(() => update("error", { show: true, code: "A001" }))
            .finally(() => setLoading(false));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <CustomDataTable
            loading={loading}
            columns={COLUMNS}
            rows={tableData}
            rowsPerPage={perPage}
            page={page}
            totalRows={totalRows}
        />
    );
}

export default BrioTags;